import { render, staticRenderFns } from "./serviceAddAdditionalProduct.vue?vue&type=template&id=0eb663f5&scoped=true"
import script from "./serviceAddAdditionalProduct.vue?vue&type=script&lang=ts"
export * from "./serviceAddAdditionalProduct.vue?vue&type=script&lang=ts"
import style0 from "./serviceAddAdditionalProduct.vue?vue&type=style&index=0&id=0eb663f5&prod&lang=scss&scoped=true"
import style1 from "./serviceAddAdditionalProduct.vue?vue&type=style&index=1&id=0eb663f5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eb663f5",
  null
  
)

export default component.exports